/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import HelpButton from 'app/components/common/HelpButton.jsx';

class QueueSectionComponent extends React.Component {
    render() {
        let timezone = this.props.user.detail.timezone,
            time = null,
            endOfTomorrow = null,
            formatted = {},
            now = moment();

        if (!timezone) {
            return null;
        }

        time = moment.tz(this.props.time * 1000, timezone);
        endOfTomorrow = moment().tz(timezone).add(1, 'days').endOf('day');


        if (time.isBefore(now)) {
            formatted = (
                <span><HelpButton which="queueRateLimit" {...this.props}/>Originally Scheduled to post {time.format('MMMM D, YYYY')}</span>
            );
        } else if (time.isBefore(endOfTomorrow)) {
            formatted = time.calendar(null, {
                sameDay: '[Today]',
                nextDay: '[Tomorrow]'
            });
        } else {
            formatted = time.format('MMMM D, YYYY');
        }

        return (
            <div className="item-group-header queue-item-group-header" data-pw="queue-day">
                {formatted}
            </div>
        );

    }

};

QueueSectionComponent.displayName = "QueueSectionComponent";

QueueSectionComponent.propTypes = {
    time: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.number
    ])
};

QueueSectionComponent.defaultProps = {
    time: new Date()
};

export default QueueSectionComponent;
